const translations = {
  "Weekly Metrics": "Weekly Metrics",
  "Total initial capital": "Total initial capital",
  "Initial capital": "Initial capital",
  "Week": "Week",
  "Profit": "Profit",
  "Net Profit": "Net Profit",
  "Return on Initial Equity": "Return on Initial Equity",
  "Return on Total Equity": "Return on Total Equity",
  "Trades": "Trades",
  "Profit Factor": "Profit Factor",
  "Percent Profitable Trades": "Percent Profitable Trades",
  "TradeList": "Trade List",
  "Search": "Search",
  "Source": "Source",
  "Type": "Type",
  "Date": "Date",
  "Price": "Price",
  "Quantity": "Quantity",
  "Cumulative Profit": "Cumulative Profit",
  "Cumulative Profit %": "Cumulative Profit %",
  "Settings": "Settings",
  "Show file info on import page": "Show file info on import page",
  "Dark Mode": "Dark Mode",
  "Show Currency Symbol": "Show Currency Symbol",
  "Currency Symbol": "Currency Symbol",
  "Language": "Language",
  "Monthly Metrics": "Monthly Metrics",
  "Month": "Month",
  "Import Data": "Import Data",
  "Drag & drop some files here, or click to select files": "Drag & drop some files here, or click to select files",
  "Show file infos": "Show file infos",
  "Include All": "Include All",
  "Include None": "Include None",
  "Remove All": "Remove All",
  "Include": "Include",
  "Name": "Name",
  "File Name": "File Name",
  "Lines": "Lines",
  "Initial Equity": "Initial Equity",
  "Recalculated Initial Equity": "Recalculated Initial Equity",
  "No files uploaded yet.": "No files uploaded yet.",
  "Confirm Deletion": "Confirm Deletion",
  "Are you sure you want to delete": "Are you sure you want to delete",
  "the file named": "the file named",
  "all files": "all files",
  "Cancel": "Cancel",
  "Confirm": "Confirm",
  "Dashboard": "Dashboard",
  "Reports": "Reports",
  "Analytics": "Analytics",
  "Logout": "Logout",
  "Main": "Main",
  "Instructions": "Instructions",
  "Imports": "Imports",
  "Metrics": "Metrics",
  "Periodical Returns": "Periodical Returns",
  "Annual": "Annual",
  "Monthly": "Monthly",
  "Weekly": "Weekly",
  "Daily": "Daily",
  "Visuals": "Visuals",
  "Equity Graphs": "Equity Graphs",
  "Drawdown Graphs": "Drawdown Graphs",
  "Others": "Others",
  "Disclaimer": "Disclaimer",
  "Metric": "Metric",
  "Value": "Value",
  "Initial Capital": "Initial Capital",
  "Total Net Profit": "Total Net Profit",
  "Gross Profit": "Gross Profit",
  "Gross Loss": "Gross Loss",
  "Pessimistic RR": "Pessimistic RR",
  "Total Trades": "Total Trades",
  "Winning Trades": "Winning Trades",
  "Losing Trades": "Losing Trades",
  "Avg Trade Net Profit": "Avg Trade Net Profit",
  "Avg Winning Trade": "Avg Winning Trade",
  "Avg Losing Trade": "Avg Losing Trade",
  "Largest Win": "Largest Win",
  "Max Cons Winners": "Max Cons Winners",
  "Largest Loss": "Largest Loss",
  "Max Cons Losers": "Max Cons Losers",
  "Trading Period": "Trading Period",
  "Total Trading Days": "Total Trading Days",
  "Longest Flat Period Days": "Longest Flat Period Days",
  "Max Drawdown": "Max Drawdown",
  "Max Drawdown As % Of Initial Equity": "Max Drawdown As % Of Initial Equity",
  "Max Drawdown As % Of Total Equity": "Max Drawdown As % Of Total Equity",
  "Max Drawdown Date": "Max Drawdown Date",
  "Max Intraday Drawdown": "Max Intraday Drawdown",
  "Max Intraday Drawdown As % Of Initial Equity": "Max Intraday Drawdown As % Of Initial Equity",
  "Max Intraday Drawdown As % Of Total Equity": "Max Intraday Drawdown As % Of Total Equity",
  "Max Intraday Drawdown Date": "Max Intraday Drawdown Date",
  "Longest Drawdown Days": "Longest Drawdown Days",
  "Recovery Factor": "Recovery Factor",
  "NP Max DD": "NP Max DD",
  "NP Intraday Max DD": "NP Intraday Max DD",
  "Avg Worst 5 DD": "Avg Worst 5 DD",
  "Avg Worst 5 DD As % Of Initial Equity": "Avg Worst 5 DD As % Of Initial Equity",
  "Max Runup": "Max Runup",
  "Max Runup As % Of Initial Equity": "Max Runup As % Of Initial Equity",
  "Max Runup As % Of Total Equity": "Max Runup As % Of Total Equity",
  "Max Runup Date": "Max Runup Date",
  "Longest Runup Days": "Longest Runup Days",
  "Margin Requirements": "Margin Requirements",
  "Return on Initial Capital": "Return on Initial Capital",
  "Annual Rate of Return": "Annual Rate of Return",
  "Avg Monthly Return": "Avg Monthly Return",
  "Std Dev Monthly Return": "Std Dev Monthly Return",
  "Percent Profitable Months": "Percent Profitable Months",
  "Sharpe Ratio": "Sharpe Ratio",
  "Sortino Ratio": "Sortino Ratio",
  "Sterling Ratio": "Sterling Ratio",
  "MAR Ratio": "MAR Ratio",
  "Efficiency Factor": "Efficiency Factor",
  "Max Intraday Runup": "Max Intraday Runup",
  "Max Intraday Runup Date": "Max Intraday Runup Date",
  "Max Intraday Runup Duration": "Max Intraday Runup Duration",
  // ...add other translations...
  "How to Import Your Trading Data:": "How to Import Your Trading Data:",
  "Note: There are still calculation bugs. Please use with care.": "Note: There are still calculation bugs. Please use with care.",
  "Step 1:": "Step 1:",
  "Export CSV Files from TradingView:": "Export CSV Files from TradingView:",
  "Open the tab as shown in the image above.": "Open the tab as shown in the image above.",
  "Click the Download button (also highlighted in the image) to export your trading list as CSV files.": "Click the Download button (also highlighted in the image) to export your trading list as CSV files.",
  "Step 2:": "Step 2:",
  "Upload CSV Files to the Application:": "Upload CSV Files to the Application:",
  'Navigate to the "Manage Data" page from the menu.': 'Navigate to the "Manage Data" page from the menu.',
  "Upload the exported CSV files.": "Upload the exported CSV files.",
  "Step 3:": "Step 3:",
  "Manage Uploaded Files:": "Manage Uploaded Files:",
  "Each uploaded file can be included in calculations by selecting it.": "Each uploaded file can be included in calculations by selecting it.",
  "You can assign a custom name to each file for better identification.": "You can assign a custom name to each file for better identification.",
  "Step 4:": "Step 4:",
  "Initial Equity Adjustment:": "Initial Equity Adjustment:",
  "The initial amount of equity is estimated by reverse-calculating from your trading data. However, this may not always produce accurate results.": "The initial amount of equity is estimated by reverse-calculating from your trading data. However, this may not always produce accurate results.",
  "After uploading each file, you can manually edit and input the correct initial equity if needed.": "After uploading each file, you can manually edit and input the correct initial equity if needed.",
  "Follow these steps to ensure accurate calculations and proper management of your trading data.": "Follow these steps to ensure accurate calculations and proper management of your trading data.",
  "Loading the magic": "Loading the magic",
  "Summoning the data wizards": "Summoning the data wizards",
  "Hold tight, data incoming": "Hold tight, data incoming",
  "Just a moment, making things awesome": "Just a moment, making things awesome",
  "Data elves are at work": "Data elves are at work",
  "Brewing some data potions": "Brewing some data potions",
  "Hang on, crunching numbers": "Hang on, crunching numbers",
  "Data is on its way": "Data is on its way",
  "Almost there, stay tuned": "Almost there, stay tuned",
  "Fetching unicorns": "Fetching unicorns",
  "Aligning the stars": "Aligning the stars",
  "Polishing the data crystals": "Polishing the data crystals",
  "Warming up the servers": "Warming up the servers",
  "Gathering the bytes": "Gathering the bytes",
  "Charging the flux capacitor": "Charging the flux capacitor",
  "Calibrating the data matrix": "Calibrating the data matrix",
  "Spinning up the hamster wheels": "Spinning up the hamster wheels",
  "Consulting the oracles": "Consulting the oracles",
  "Synchronizing the clocks": "Synchronizing the clocks",
  "Yearly Metrics": "Yearly Metrics",
  "Daily Metrics": "Daily Metrics",
  "January": "January",
  "February": "February",
  "March": "March",
  "April": "April",
  "May": "May",
  "June": "June",
  "July": "July",
  "August": "August",
  "September": "September",
  "October": "October",
  "November": "November",
  "December": "December",
  "Trading Metrics": "Trading Metrics",
  "Loading...": "Loading...",
  "Config": "Config",
  "Config File Name": "Config File Name",
  "No config file": "No config file",
  "Config File Content": "Config File Content",
  "Confirm Config Deletion": "Confirm Config Deletion",
  "Are you sure you want to delete the config file for": "Are you sure you want to delete the config file for",
  "Close": "Close",
  "tradingRange": "Trading Range",
  "backtestingRange": "Backtesting Range",
  "symbol": "Symbol",
  "timeframe": "Timeframe",
  "chartType": "Chart Type",
  "pointValue": "Point Value",
  "currency": "Currency",
  "tickSize": "Tick Size",
  "precision": "Precision",
  "initialCapital": "Initial Capital",
  "orderSize": "Order Size",
  "pyramiding": "Pyramiding",
  "commission": "Commission",
  "slippage": "Slippage",
  "verifyPriceForLimitOrders": "Verify Price For Limit Orders",
  "marginForLongPositions": "Margin For Long Positions",
  "marginForShortPositions": "Margin For Short Positions",
  "recalculateAfterOrderIsFilled": "Recalculate After Order Is Filled",
  "recalculateOnEveryTick": "Recalculate On Every Tick",
  "recalculateOnBarClose": "Recalculate On Bar Close",
  "backtestingPrecisionUseBarMagnifier": "Backtesting Precision Use Bar Magnifier",
  "Expert Mode": "Expert Mode",
  "Select Metrics": "Select Metrics",
  "Additional Expert Mode Metrics": "Additional Expert Mode Metrics",
  "Select All": "Select All",
  "Deselect All": "Deselect All",
  "Open Metrics Popup": "Open Metrics Popup",
  "View and Select Metrics": "View and Select Metrics",
  "Show Advanced Metrics": "Show Advanced Metrics",
  "Monthly Profit and Loss": "Monthly Profit and Loss",
  "Monthly Graphs": "Monthly Graphs",
  "Profits and Losses": "Profits and Losses",
  "Total Wins": "Total Wins",
  "Total Losses": "Total Losses",
  "(Optional) How to Import And Remember Your Backtest Configuration:": "(Optional) How to Import And Remember Your Backtest Configuration:",
  "Export Configuration:": "Export Configuration:",
  "Navigate to the 'Configuration' page in the TradingView backtester.": "Navigate to the 'Configuration' page in the TradingView backtester.",
  "Click the 'Export' button to save your current configuration.": "Click the 'Export' button to save your current configuration.",
  "Import Configuration:": "Import Configuration:",
  "Click the 'Import' button in the config column of your entries row and upload the exported csv file.": "Click the 'Import' button in the config column of your entries row and upload the exported csv file.",
  "Manage Configuration:": "Manage Configuration:",
  "You can view your configuration again as needed by clicking on the eye icon.": "You can view your configuration again as needed by clicking on the eye icon.",
  "Open the tab 'List of Trades' in the TradingView backtester as shown in the image above.": "Open the tab 'List of Trades' in the TradingView backtester as shown in the image above.",
  "Use deep backtest": "Use deep backtest",
  "Start Date": "Start Date",
  "End Date": "End Date",
  "Active dataset": "Active dataset",
  "Manage Datasets": "Manage Datasets",
  "Number of Files": "Number of Files",
  "First Trade": "First trade",
  "Last Trade": "Last Trade",
  "All files": "All files",
  "Included files": "Included files",
  "Number of Trades": "Number of trades",
  "Confirm Dataset Deletion": "Confirm Dataset Deletion",
  "Are you sure you want to delete the dataset named": "Are you sure you want to delete the dataset named",
  "Add New Dataset": "Add New Dataset",
  "Dataset Name": "Dataset Name",
  "Add": "Add",
  "Manage Data": "Manage Data",
  "Confirm Initial Capital": "Confirm Initial Capital",
  "Initial Capital from Config": "Initial Capital from Config",
  "Add Dataset": "Add Dataset",
  "Timestamp": "Timestamp",
  "days": "days",
};

// Reminder: Don't forget to translate the MUI X filter phrases.
export default translations;